import { toCdnAssetUrl } from "./asset-cdn";

export function getStrapiURL(path = "") {
  return `${
    process.env.NEXT_PUBLIC_STRAPI_API_URL || "http://localhost:1337"
  }${path}`;
}

// True if the URL points to an SVG (ignoring query params, e.g. S3 signed URLs).
// SVGs don't benefit from the image optimizer and break it unless dangerouslyAllowSVG
// is set, so we render them with `unoptimized` to serve them directly.
export function isSvgUrl(url?: string | null): boolean {
  if (!url) return false;
  const path = url.split("?")[0].split("#")[0];
  return path.toLowerCase().endsWith(".svg");
}

export function getStrapiMedia(url: string | undefined) {
  if (url == null) {
    return null;
  }

  // Return the full URL if the media is hosted on an external provider
  // (S3 links are mapped to CloudFront so they never carry a signature).
  if (url.startsWith("http") || url.startsWith("//")) {
    return toCdnAssetUrl(url);
  }

  // Otherwise prepend the URL path with the Strapi URL
  return `${getStrapiURL()}${url}`;
}

export function formatDate(dateString: string) {
  return new Date(dateString)
    .toLocaleDateString("ro-RO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    .toLocaleLowerCase();
}

// ADDS DELAY TO SIMULATE SLOW API REMOVE FOR PRODUCTION
export const delay = (time: number) =>
  new Promise((resolve) => setTimeout(() => resolve(1), time));


const allowedTags = ["h1", "h2", "h3", "h4", "h5", "h6", "div"] as const;

export const getSafeHeading = (
    level?: string,
    defaultLevel: keyof JSX.IntrinsicElements = "h3"
): keyof JSX.IntrinsicElements => {
    return allowedTags.includes(level?.toLowerCase() as any)
        ? (level!.toLowerCase() as keyof JSX.IntrinsicElements)
        : defaultLevel;
};